<script lang="ts" setup></script>

<template>
  <div id="landing-page">
    <div id="landing-content">
      <img
        src="@/assets/images/logo-light.svg"
        class="logo"
        alt="Sampling Human"
      /><br />
      <h1>Oops!</h1>
      <h2>We can't seem to find the page you are looking for.</h2>
      <router-link to="/">
        <button class="btn enter">
          <i class="fa fa-line-chart"></i> Go Home
        </button>
      </router-link>
      <p class="links">
        or go to
        <a href="https://samplinghuman.com" class="user">samplinghuman.com</a>
      </p>
    </div>
  </div>
</template>
